<template>
  <section class="page--section" v-if="showActivity && supportedFeaturesOutbox">
    <el-select v-if="users.length" v-model="selectedViewAs" class="view-as"
      :placeholder="$t('accountSettingsActivityViewAs')" @change="viewAsChange">
      <el-option :key="0" :value="0" :label="$t('accountSettingsActivityViewAsMe')" />
      <el-option v-for="user in users" :key="user.id" :value="user.uid" :label="userDisplayName(user)" />
    </el-select>
    <h2 class="section__title">{{ $t('accountSettingsActivityHeadline') }}</h2>
    <el-tabs type="card">
      <el-tab-pane v-if="supportedFeaturesOutbox" :label="$t('accountSettingsOutboxActivityTabLabel')">
        <user-activity-log-outbox />
      </el-tab-pane>
    </el-tabs>
  </section>
</template>


<script>
import UserActivityLogOutbox from '@/components/activity/UserActivityLogOutbox.vue';
import { mapState, mapActions, mapGetters } from 'vuex';
import get from 'lodash.get';
import activity from '@/components/activity';
import user from '@/components/user';
import mixins from '@/mixins';

export default {
  name: 'UserActivity',
  mixins: [
    mixins.supportedFeatures
  ],
  data() {
    return { selectedViewAs: null };
  },
  computed: {
    ...mapState(activity.store.namespace, [
      'activityMediaData',
      'activityMediaUrl',
    ]),
    ...mapState(user.store.namespace, [
      'currentUser',
    ]),
    ...mapGetters(user.store.namespace, [
      'region'
    ]),
    showActivity,
    users,
  },
  methods: {
    ...mapActions(activity.store.namespace, [
      'loadMediaPage',
      'refreshMediaPage',
      'setViewAs',
    ]),
    viewAsChange,
    userDisplayName,
  },
  components: {
    UserActivityLogOutbox,
  },
  beforeMount() {
    this.setViewAs(null);
  }
}

function users() {
  const dealership = this.currentUser.dealership;
  if (dealership && dealership.length) {
    return dealership;
  }
  return [];
}

function showActivity() {
  return this.activityMediaData.length ||
    this.activityMediaUrl ||
    this.users.length;
}

function viewAsChange(value) {
  let user = this.users.find(u => u.uid === value);
  this.setViewAs(user);
}

function userDisplayName(user) {
  return get(user, 'name', get(user, 'email'));
}
</script>

<style lang="scss">
.view-as {
  width: auto;
  float: right;
}
</style>
